import { render, staticRenderFns } from "./SubscriptionPage.vue?vue&type=template&id=66532952&scoped=true&"
import script from "./SubscriptionPage.vue?vue&type=script&lang=js&"
export * from "./SubscriptionPage.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionPage.vue?vue&type=style&index=0&id=66532952&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66532952",
  null
  
)

export default component.exports